(function () {
  if (window.__protoGridLoaded) return;
  window.__protoGridLoaded = true;

  function dispatchCartEvents(payload, button) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', { detail: { open: true, payload: payload } })
    );
    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: { product: payload, addToCartBtn: button },
      })
    );

    if (typeof window.updateCartDrawer === 'function') {
      window.updateCartDrawer(true);
    }
  }

  function initQuickAdd() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-proto-quick-add]');
      if (!button) return;

      event.preventDefault();

      if (button.disabled || button.classList.contains('proto-card__loading')) {
        return;
      }

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      button.disabled = true;
      button.classList.add('proto-card__loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      })
        .then(function (response) {
          if (!response.ok) throw response;
          return response.json();
        })
        .then(function (payload) {
          dispatchCartEvents(payload, button);
        })
        .catch(function (error) {
          if (typeof console !== 'undefined' && console.error) {
            console.error('ProtoClinical quick add failed', error);
          }
        })
        .finally(function () {
          button.disabled = false;
          button.classList.remove('proto-card__loading');
        });
    });
  }

  function updateRailButtons(rail) {
    var viewport = rail.querySelector('[data-proto-rail-viewport]');
    if (!viewport) return;

    var prev = rail.querySelector('[data-proto-rail-prev]');
    var next = rail.querySelector('[data-proto-rail-next]');
    if (!prev || !next) return;

    var maxScroll = viewport.scrollWidth - viewport.clientWidth - 2;
    prev.disabled = viewport.scrollLeft <= 2;
    next.disabled = viewport.scrollLeft >= maxScroll;
  }

  function initRails() {
    document.querySelectorAll('[data-proto-rail]').forEach(function (rail) {
      var viewport = rail.querySelector('[data-proto-rail-viewport]');
      if (!viewport) return;

      var prev = rail.querySelector('[data-proto-rail-prev]');
      var next = rail.querySelector('[data-proto-rail-next]');
      var hint = rail.querySelector('[data-proto-rail-hint]');

      function scrollByAmount(direction) {
        var amount = Math.max(viewport.clientWidth * 0.85, 220) * direction;
        viewport.scrollBy({ left: amount, behavior: 'smooth' });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollByAmount(-1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          scrollByAmount(1);
        });
      }

      viewport.addEventListener('scroll', function () {
        updateRailButtons(rail);
      });

      if (hint) {
        viewport.addEventListener(
          'scroll',
          function () {
            hint.hidden = viewport.scrollLeft > 8;
          },
          { once: true }
        );
      }

      updateRailButtons(rail);
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-proto-tabs]').forEach(function (tabsRoot) {
      var tabs = Array.prototype.slice.call(
        tabsRoot.querySelectorAll('[role="tab"]')
      );
      var panels = Array.prototype.slice.call(
        tabsRoot.querySelectorAll('[role="tabpanel"]')
      );
      if (!tabs.length || !panels.length) return;

      function activateTab(tab) {
        var target = tab.getAttribute('aria-controls');

        tabs.forEach(function (item) {
          var selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.id !== target;
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateTab(tab);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex !== index) {
            event.preventDefault();
            tabs[nextIndex].focus();
            activateTab(tabs[nextIndex]);
          }
        });
      });
    });
  }

  function defineProductRecommendations() {
    if (customElements.get('product-recommendations')) return;

    customElements.define(
      'product-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.dataset.url) return;
          var self = this;

          function loadRecommendations(entries, observer) {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();

            fetch(self.dataset.url)
              .then(function (response) {
                return response.text();
              })
              .then(function (text) {
                var wrapper = document.createElement('div');
                wrapper.innerHTML = text;
                var incoming = wrapper.querySelector('product-recommendations');
                if (incoming && incoming.innerHTML.trim().length) {
                  self.innerHTML = incoming.innerHTML;
                }
              })
              .catch(function (error) {
                if (typeof console !== 'undefined' && console.error) {
                  console.error('ProtoClinical recommendations failed', error);
                }
              });
          }

          if ('IntersectionObserver' in window) {
            new IntersectionObserver(loadRecommendations, {
              rootMargin: '0px 0px 320px 0px',
            }).observe(this);
          }
        }
      }
    );
  }

  function trackRecentlyViewed() {
    document.querySelectorAll('[data-proto-track-product]').forEach(function (node) {
      var handle = node.getAttribute('data-product-handle');
      if (!handle) return;

      try {
        var stored = JSON.parse(localStorage.getItem('protoRecentlyViewed') || '[]');
        var entry = {
          handle: handle,
          url: node.getAttribute('data-product-url') || '',
          title: node.getAttribute('data-product-title') || '',
          vendor: node.getAttribute('data-product-vendor') || '',
          descriptor: node.getAttribute('data-product-descriptor') || '',
          price: node.getAttribute('data-product-price') || '',
          image: node.getAttribute('data-product-image') || '',
          image_alt: node.getAttribute('data-product-image-alt') || '',
          width: node.getAttribute('data-product-image-width') || '600',
          height: node.getAttribute('data-product-image-height') || '600',
        };

        stored = stored.filter(function (item) {
          return item.handle !== entry.handle;
        });
        stored.unshift(entry);
        localStorage.setItem('protoRecentlyViewed', JSON.stringify(stored.slice(0, 12)));
      } catch (error) {
        if (typeof console !== 'undefined' && console.error) {
          console.error('ProtoClinical recently viewed tracking failed', error);
        }
      }
    });
  }

  function renderRecentlyViewed() {
    document
      .querySelectorAll('[data-proto-recently-viewed-shell]')
      .forEach(function (shell) {
        var root = shell.closest('[data-proto-recently-viewed-root]');
        var viewport = shell.querySelector('[data-proto-recently-viewed-grid]');
        if (!root || !viewport) return;

        var maxItems = Number(root.getAttribute('data-max-items') || 4);

        try {
          var items = JSON.parse(localStorage.getItem('protoRecentlyViewed') || '[]')
            .filter(function (item) {
              return item && item.handle;
            })
            .slice(0, maxItems);

          if (!items.length) {
            root.hidden = true;
            return;
          }

          viewport.innerHTML = items
            .map(function (item) {
              return (
                '<article class="proto-card proto-card--product">' +
                '<div class="proto-card__media">' +
                '<a class="proto-card__media-link" href="' +
                item.url +
                '">' +
                '<span class="proto-card__media-frame" style="--proto-card-ratio: 1 / 1;">' +
                '<img src="' +
                item.image +
                '" alt="' +
                (item.image_alt || '') +
                '" width="' +
                item.width +
                '" height="' +
                item.height +
                '" loading="lazy">' +
                '</span>' +
                '</a>' +
                '</div>' +
                '<div class="proto-card__body">' +
                (item.vendor
                  ? '<p class="proto-card__kicker">' + item.vendor + '</p>'
                  : '') +
                '<h3 class="proto-card__title"><a class="proto-card__title-link" href="' +
                item.url +
                '">' +
                item.title +
                '</a></h3>' +
                (item.descriptor
                  ? '<p class="proto-card__descriptor">' + item.descriptor + '</p>'
                  : '') +
                (item.price
                  ? '<div class="proto-card__price-row"><span class="proto-card__price">' +
                    item.price +
                    '</span></div>'
                  : '') +
                '<div class="proto-card__actions"><a class="proto-card__action" href="' +
                item.url +
                '">View Product</a></div>' +
                '</div>' +
                '</article>'
              );
            })
            .join('');
        } catch (error) {
          root.hidden = true;
        }
      });
  }

  function init() {
    defineProductRecommendations();
    initQuickAdd();
    initRails();
    initTabs();
    trackRecentlyViewed();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
